import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import Fetchbookmarks from '../components/Fetchbookmarks';
function MyBookmarks() {
 

  if (!localStorage.getItem('user-info')) {
    return <Navigate to="/" />
} else{
  return (
    <>
        <div class="tabs-content t-h-content" data-tabs-content="bookmark-tabs">
          <div class="tabs-panel is-active padding-horizontal-0" id="panel1">
            
              <Fetchbookmarks  classwrapper="grid-x grid-margin-x articles-list small-12 medium-up-3" urlrelativepath="mybookmarkarticle" contenttype="article"  labelname="مقالات"  />
  
          </div>

          <div class="tabs-panel  padding-horizontal-0" id="panel2">
          <div class="podcast-grid podcast-opinion-grid ">
             
              <Fetchbookmarks  classwrapper="podcast-list audio-podcast audio-podcast--no-bar grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-3"   urlrelativepath="mybookmarkopinion" contenttype="opinion" labelname="مقالات رأي"   />
           
          </div>
          </div>


          <div class="tabs-panel  padding-horizontal-0" id="panel3">
        
              <Fetchbookmarks  classwrapper="grid-x grid-margin-x articles-list small-12 medium-up-3"  urlrelativepath="mybookmarkmultimedia" contenttype="multimedia" labelname="فيديو"  />
           
          </div>


          <div class="tabs-panel  padding-horizontal-0" id="panel4">
          <div class="podcast-grid podcast-opinion-grid">
              
              <Fetchbookmarks classwrapper="podcast-list grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-3"  urlrelativepath="mybookmarkpodcast" contenttype="podcast" labelname="بودكاست"  />
           
            </div>
          </div>


          <div class="tabs-panel  padding-horizontal-0" id="panel5">
           
              <Fetchbookmarks classwrapper="grid-x grid-margin-x articles-list small-12 medium-up-3"   urlrelativepath="mybookmarkalbum" contenttype="album" labelname="البومات" />
            
          </div>
        </div>
    </>
  );
  }

}
export default MyBookmarks;
